import { render } from "./UiRenderer.vue?vue&type=template&id=63796d0e&lang=pug"
import script from "./UiRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./UiRenderer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__